import { type IActivityTemplateWithoutPatient } from "@/api/Templates";
import { CompetenceFilter } from "@/pages/template-manager/CompetenceFilter";
import { useTemplateManagerCompetenceFilter } from "@/pages/template-manager/useTemplateManagerCompetenceFilter";
import { sortActivityTemplates } from "@/pages/template-manager/templateManagerUtils";
import { NO_PATIENT_SELECTED } from "@/pages/commandcenter/NewActivity/newActivityUtils";
import { TemplatesContextProvider } from "./TemplatesContextProvider";
import { ActivityTemplate } from "./ActivityTemplate";
import styles from "./Templates.module.scss";

export const TemplatesWithoutPatient = ({
  defaultStartDate,
  activityTemplatesWithoutPatient,
}: {
  defaultStartDate: Date | undefined;
  activityTemplatesWithoutPatient: IActivityTemplateWithoutPatient[];
}) => {
  return (
    <TemplatesContextProvider
      initialPatientId={NO_PATIENT_SELECTED}
      initialDefaultStartDate={defaultStartDate}
    >
      <TemplatesWithoutPatientList
        activityTemplatesWithoutPatient={activityTemplatesWithoutPatient}
      />
    </TemplatesContextProvider>
  );
};

const TemplatesWithoutPatientList = ({
  activityTemplatesWithoutPatient,
}: {
  activityTemplatesWithoutPatient: IActivityTemplateWithoutPatient[];
}) => {
  const { filteredCompetence, selectCompetence, matchesCompetenceFilter } =
    useTemplateManagerCompetenceFilter(
      "templatesWithoutPatient.competenceFilter",
    );

  const filteredTemplates = activityTemplatesWithoutPatient.filter((template) =>
    matchesCompetenceFilter(template),
  );

  return (
    <div className={styles.templatesContainer}>
      <CompetenceFilter
        filteredCompetence={filteredCompetence}
        selectCompetence={selectCompetence}
      />
      <ul className={styles.listGroup}>
        {sortActivityTemplates([...filteredTemplates]).map((template) => (
          <li key={template.templateId}>
            <ActivityTemplate template={template} />
          </li>
        ))}
      </ul>
    </div>
  );
};
